
namespace RioERP.Masters {

    @Serenity.Decorators.registerClass()
    export class SmsTemplateVariablesGrid extends Serenity.EntityGrid<SmsTemplateVariablesRow, any> {
        protected getColumnsKey() { return SmsTemplateVariablesColumns.columnsKey; }
        protected getDialogType() { return SmsTemplateVariablesDialog; }
        protected getIdProperty() { return SmsTemplateVariablesRow.idProperty; }
        protected getInsertPermission() { return SmsTemplateVariablesRow.insertPermission; }
        protected getLocalTextPrefix() { return SmsTemplateVariablesRow.localTextPrefix; }
        protected getService() { return SmsTemplateVariablesService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}